import { AccountDropdownButton } from "@/components/buttons/AccountDropdownButton";
import type { EmbedPage } from "@/features/supabase";
import { useGetCurrentUserQuery } from "@/store/services/supabase";
import { ArrowLeftOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import Link from "next/link";
import { DatasetSelectButton } from "./DatasetSelectButton";
interface TopBarProps {
  selectedDataset: EmbedPage | undefined;
  isSidebarOpen: boolean;
  onOpenDatasetSelect: () => void;
  onToggleSidebar: () => void;
}
export const TopBar = ({
  selectedDataset,
  isSidebarOpen,
  onOpenDatasetSelect,
  onToggleSidebar
}: TopBarProps) => {
  const {
    data: user
  } = useGetCurrentUserQuery();
  return <div className="flex h-12 max-h-12 min-h-12 items-center justify-between gap-4 border-b border-gray-200 pl-2 pr-4" data-sentry-component="TopBar" data-sentry-source-file="TopBar.tsx">
      <div className="flex min-w-0 items-center gap-3">
        <Link href="/" data-sentry-element="Link" data-sentry-source-file="TopBar.tsx">
          <Button type="text" icon={<ArrowLeftOutlined />} data-sentry-element="Button" data-sentry-source-file="TopBar.tsx" />
        </Link>

        <DatasetSelectButton selectedDataset={selectedDataset} onClick={onOpenDatasetSelect} data-sentry-element="DatasetSelectButton" data-sentry-source-file="TopBar.tsx" />
      </div>

      <div className="flex shrink-0 items-center gap-2">
        {selectedDataset && <Tooltip title={isSidebarOpen ? "Hide dataset details" : "Show dataset details"}>
            <Button type={isSidebarOpen ? "default" : "text"} icon={<InfoCircleOutlined />} aria-label="Toggle dataset details" onClick={onToggleSidebar} />
          </Tooltip>}
        {!!user && <AccountDropdownButton {...user} />}
      </div>
    </div>;
};